import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import { getThought } from "../Service/Api"; 
const Thought = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
   const fetchData = async () => {
     try {
       const data = await getThought();
       console.log(data)
       setData(data);
     } catch (error) {
       console.error("Error fetching online registration data:", error);
     }  
   };
   fetchData();
 }, []); 
  return (
    <>
    <div class="thought">
    <div className="container fulwidth">
        <div className="row">
           <div className="col-lg-12">
               <div className="maintitle">
                  <h1>Today's Thought</h1> 
               </div>
           </div>
           </div>
           {data.length > 0 && (
           <div className="row"> 
             <div className="col-lg-3">
             <LazyLoad>
              <a data-magnify="gallery" data-src="" data-group="a" href="{`https://webapi.entab.info/api/image?url=${data.attachments}">
                 <img src="{`https://webapi.entab.info/api/image?url=${data.attachments}" className="img-fluid" alt="STPCSH"/> 
             </a>
            </LazyLoad> 
                  </div>
                  <div className="col-lg-9">
                    <div className="thoughtdesc">
                    <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p>
                    </div>
              </div>
          </div>
          )}  
           
         </div>
    </div> 
    </>
  )
}

export default Thought
